<template>
    <div v-if="isLoading">
        <font-awesome-icon icon="spinner" spin/>
    </div>
    <div v-else-if="hasErrorCheckingStepAllowed">
        <b-alert variant="danger" show>
            <p>
                Er is iets fout gegaan bij de controle of dit product meerdere malen mag worden toegevoegd aan de order.<br/>
                Voeg <span class="font-size-xlg">alleen het gescande item</span> toe aan de order en ga door.
            </p>
            <b-button @click="save" variant="primary">Volgende</b-button>
        </b-alert>
    </div>
    <div v-else>
        <p>
            Je kan <strong class="font-size-xlg">{{ unscannedQuantityInLine ?? 'onbekend' }}</strong> van het gescande product
            <span v-if="dispatchRequest">
                toevoegen aan deze order.
                Geef aan hoeveel je er wilt toevoegen:
            </span>
            <span v-else>
                verwerken.
                Geef aan hoeveel je er wilt verwerken:
            </span>
        </p>

        <form @submit.prevent="save">
            <b-input type="number" v-model.number="quantityToAdd" min="1" :max="unscannedQuantityInLine" class="d-inline-block" style="width:100px;"
                     autofocus
                     ref="valueInput"
            />
            <b-button type="submit" variant="primary" class="ml-2">Toevoegen</b-button>
        </form>

    </div>
</template>

<script>
import DownloadPackingSlipButton from "../../OrderDetail/components/DownloadPackingSlipButton.vue";
import SpecialProcessProvideExtraProductInfo from "./SpecialProcessProvideExtraProductInfo.vue";
import ProcessSort from "../ProcessSort.vue";

export default {
    name: "SpecialProcessMultipleQuantities",
    components: {DownloadPackingSlipButton},

    props: {
        location: {required: true},
        dispatchRequest: {required: true},
        scannedLine: {required: true},
    },

    data() {
        return {
            isLoading: false, // Loading is deprecated, but if it's ever needed again you can enable it easily
            hasErrorCheckingStepAllowed: false,
            autoContinueSeconds: 5,
            unscannedQuantityInLine: null,
            quantityToAdd: 1,
            refocusInterval: setInterval(() => this.$refs['valueInput']?.focus(), 500),
        }
    },

    mounted() {

    },

    beforeDestroy() {
        clearInterval(this.refocusInterval)
    },

    methods: {
        getIdentifier() {
            return 'multiple_quantities'
        },
        isRequired(batchModelType, productIdentifier, dispatchRequest, sortingLocation, isLastScan, scannedLine) {
            // The to-be-scanned quantity must be >1 because otherwise this step isn't necessary
            let drqLine = dispatchRequest?.dispatch_request_lines?.find(line => line.ean_codes.includes(productIdentifier))
            if (!drqLine) {
                if (scannedLine?.goods_receipt_id && scannedLine.cascaded_quantity_pending > 0) {
                    this.unscannedQuantityInLine = scannedLine.cascaded_quantity_pending
                }
                else {
                    return Promise.resolve(false)
                }
            }
            else {
                this.unscannedQuantityInLine = Math.min(drqLine.cascaded_quantity_pending, scannedLine?.cascaded_quantity_pending)
            }

            return Promise.resolve(this.unscannedQuantityInLine > 1)
        },
        onShow() {
            const currentProductQuantity = ProcessSort.methods.getCurrentProductQuantity()
            if (currentProductQuantity) {
                this.quantityToAdd = currentProductQuantity
                this.save()
                return
            }

            this.quantityToAdd = this.unscannedQuantityInLine;
        },
        save() {
            clearInterval(this.refocusInterval);
            this.$emit('success', {quantity: this.quantityToAdd})
        },
    },

    watch: {
        autoContinueSeconds(newVal) {
            if (newVal === 0) {
                this.save()
            }
        },
    },
}
</script>

<style scoped>

</style>
